import React, { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import Navbar from "components/Navbar";
import Sidebar from "components/Sidebar";

const Layout = () => {
    const isNonMobile = useMediaQuery("(min-width: 600px)");
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    return (
        <Box display={isNonMobile ? "flex" : "block"} width="100%" height="100%" sx={{ backgroundColor: "#f4f6f9" }}>
            <Sidebar user={{}} isNonMobile={isNonMobile} drawerWidth="250px" isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
            <Box flexGrow={1} sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <Navbar user={{}} isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
                <Box sx={{ flex: 1 }}><Outlet /></Box>
            </Box>
        </Box>
    );
};

export default Layout;
